// extracted by mini-css-extract-plugin
module.exports = {"profileImage":"AccountBubble_profileImage__3l3FI","bubbleContainer":"AccountBubble_bubbleContainer__14dQa"};